import { Slot } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import styles from './unstyled-button.module.scss';

type UnstyledButtonProps = {
  asChild?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const UnstyledButton = Object.assign(
  forwardRef<HTMLButtonElement, UnstyledButtonProps>(
    ({ className, asChild = false, ...props }, ref) => {
      const Comp = asChild ? Slot : 'button';

      return (
        <Comp className={clsx(className, styles.btn)} ref={ref} {...props} />
      );
    }
  ),
  {
    className: styles.btn,
  }
);
UnstyledButton.displayName = 'UnstyledButton';

export { UnstyledButton };
export type { UnstyledButtonProps };
